<template>
  <NuxtLink
    :to="to"
    class="group flex h-full flex-col overflow-hidden rounded-3xl border border-[var(--ui-border)] bg-[var(--arad-surface)] transition hover:border-primary/40"
  >
    <img
      v-if="post.coverUrl"
      :src="post.coverUrl"
      :alt="post.title"
      class="aspect-[16/9] w-full object-cover"
    >
    <div class="flex flex-1 flex-col gap-2 p-4">
      <div class="flex flex-wrap items-center gap-2 text-xs text-[var(--ui-text-muted)]">
        <span v-if="post.category">{{ post.category.title }}</span>
        <span v-if="post.publishedAt">{{ faDate(post.publishedAt, 'short') }}</span>
        <span>{{ toFaDigits(post.readingMinutes) }} دقیقه مطالعه</span>
      </div>
      <h3 class="line-clamp-2 min-h-14 text-lg font-semibold leading-7 group-hover:text-primary">
        {{ post.title }}
      </h3>
      <p class="line-clamp-3 min-h-[4.5rem] flex-1 text-sm leading-6 text-[var(--ui-text-muted)]">
        {{ post.excerpt }}
      </p>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import type { BlogPostListItem } from '~/types/blog'
import { faDate } from '~/utils/faDate'
import { toFaDigits } from '~/utils/faDigits'

const props = defineProps<{
  post: BlogPostListItem
}>()

const to = computed(() => `/blog/${encodeURIComponent(props.post.slug)}`)
</script>
